import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useTranslation } from "react-i18next";

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleReturnToPricing = () => {
    navigate('/dashboard/extrapages/pricing-plans');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div id='content-page' className='content-page'>
      <Container>
        <Row>
          <Col sm="12">
            <Card className="position-relative inner-page-bg bg-primary" style={{ height: "150px" }}>
              <div className="inner-page-title">
                <h3 className="text-white">{t("Payment cancelled")}</h3>
                <p className="text-white">{t("Your payment has been cancelled")}</p>
              </div>
            </Card>
          </Col>
          
          <Col md={8} className="mx-auto mt-4">
            <Paper elevation={3} sx={{ p: 5, borderRadius: 2, textAlign: 'center' }}>
              <CancelOutlinedIcon sx={{ fontSize: 80, color: 'error.main', mb: 3 }} />
              
              <Typography variant="h4" gutterBottom>
                Paiement annulé
              </Typography>
              
              <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                {t("Your payment has been cancelled. No amount has been charged to your account.")}
                {t("If you encounter any difficulties or have any questions, do not hesitate to contact our support.")}
              </Typography>
              
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Button 
                  variant="contained" 
                  color="primary"
                  onClick={handleReturnToPricing}
                  sx={{ px: 4, py: 1.5 }}
                >
                  {t("Back to plans")}
                </Button>
                
                <Button 
                  variant="outlined" 
                  color="inherit"
                  onClick={handleGoHome}
                  sx={{ px: 4, py: 1.5 }}
                >
                  {t("Back to home")}
                </Button>
              </Box>
            </Paper>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentCancel;
